module.exports = __webpack_public_path__ + "media/images/reg_1_redesign_status_spritesheet-a3863626.png";